import { OperatorApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeOperators } from './normalizers';
import { Operator } from './types';

export class VoladeumOperators extends Axios {
  async list(): Promise<VoladeumResponse<Operator[]>> {
    const res = await this.get<VoladeumResponse<OperatorApi[]>>('/v1/lookups/operators');
    return {
      success: res.success,
      error: res.error,
      data: normalizeOperators(res.data),
    };
  }
}
